export type WithVerifiedLocation = {
  location_verified_at?: number;
};

export function isLocationVerified({
  location_verified_at,
}: WithVerifiedLocation): boolean {
  return !!location_verified_at;
}
